
import React, { useRef, useState } from 'react';
import { GetGeneralRulesData } from '../../../redux/api/generalRules';
import { GetPlatformRules } from '../../../redux/api/platformRules';
import { GetRegulationData } from '../../../redux/api/regulation';
import { useForm } from 'react-hook-form';
import { registerFormValidation } from '../validations';
import { yupResolver } from '@hookform/resolvers';
import { defaultToken, initialFormValues } from '../mocks';
import { useTranslation } from 'react-i18next';
import { GetContact } from '../../../redux/api/footer';
import { GetThemeColorFromStorage, GetThemeFromAPI } from '../../../redux/api/themeColor';
import { useHistory, useLocation } from 'react-router-dom';
import { CreatePasswordForSimplified, } from '../../../redux/api/consumer';
import { formatCreatePasswordForSimplified } from '../functions';

export default function useSimplifiedRegistration() {
  const { t } = useTranslation()
  const history = useHistory();
  const location = useLocation();

  const [contact, setContat] = useState()
  const [loading, setLoading] = useState(false)
  const [generalRules, setGeneralRules] = useState()
  const [themeColor, setThemeColor] = useState(GetThemeColorFromStorage())
  const termRef = useRef(false)
  const regulationRef = useRef(false)
  const [sucess, setSuccess] = useState(false)
  const [snackStatus, setSnackStatus] = useState({
    open: false,
    message: '',
    severity: 'success',
  })

  const userInfo = location.state?.userInfo;

  const [open, setOpen] = useState({
    useTerms: false,
    regulation: false,
  })

  const { control, clearErrors, errors, setValue, watch, handleSubmit, setError, trigger } = useForm({
    mode: 'all',
    defaultValues: initialFormValues,
    resolver: yupResolver(registerFormValidation),
  })

  const getInitialData = async () => {
    setLoading(true)

    try {
      const [generalRules, platformRules, regulationData, contact, themeFromAPI] = await Promise.all([
        GetGeneralRulesData(),
        GetPlatformRules(),
        GetRegulationData(),
        GetContact(),
        GetThemeFromAPI(),
      ])


      if (themeFromAPI?.data) {
        setThemeColor(themeFromAPI.data)
      }

      setContat(contact)
      setGeneralRules({
        ...generalRules,
        allowIndications: generalRules?.allowIndications,
        corporationPartners: generalRules?.hasCorporationPartners,
        useTerms: platformRules?.useTerms,
        regulation: regulationData?.regulation,
      })
    } catch (error) {
      console.error('Erro ao buscar dados iniciais:', error)
    } finally {
      setLoading(false)
    }
  }


  const handleClick = (name) => {
    if (name === 'useTerms') {
      if (termRef.current) {
        termRef.current.innerHTML = generalRules.useTerms
      }
    }

    if (name === 'regulation') {
      if (regulationRef.current) {
        regulationRef.current.innerHTML = generalRules.regulation
      }
    }
    setOpen({ ...open, [name]: !open[name] })
  }

  const handleClose = () => {
    setOpen({
      useTerm: false,
      regulation: false,
    })
  }

  const onSubmit = async (data) => {
    setLoading(true)
    try {

      const values = formatCreatePasswordForSimplified({
        ...userInfo?.data?.user, ...data
      })
      const response = await CreatePasswordForSimplified(values, userInfo?.data?.token)

      if (response?.data?.errors?.length > 0) {
        const errorMessage = response?.data?.errors[0]?.message

        if (errorMessage === 'Email - EMAIL_DUPLICADED') {
          setError('email', {
            type: 'manual',
            message: t(errorMessage),
          })
          return
        }
        setSnackStatus({
          open: true,
          severity: 'error',
          text: t(response?.data?.errors[0]?.message),
        })
      }

      if (response?.status === 200 && response?.data?.success) {
        setSuccess(true)
      }

    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  const closeSnack = () => {
    setSnackStatus({
      open: false,
      message: '',
      severity: 'success',
    })
  }

  return {
    t,
    open,
    watch,
    errors,
    control,
    contact,
    loading,
    setValue,
    themeColor,
    clearErrors,
    generalRules,
    getInitialData,
    termRef,
    sucess,
    onSubmit,
    trigger,
    handleSubmit,
    regulationRef,
    history,
    handleClick,
    handleClose,
    closeSnack,
    snackStatus,
  }
}

